var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckmarkInCircleNoOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AA06DB6F-84AB-4DC6-9853-D79164E54E3C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-to-brand_Button_States",
    transform: "translate(-258.000000, -99.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/checkmark-update-F",
    transform: "translate(257.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1.5 C14.7222222,1.5 18.5,5.27777778 18.5,10 C18.5,14.7222222 14.7222222,18.5 10,18.5 C5.27777778,18.5 1.5,14.7222222 1.5,10 C1.5,5.27777778 5.27777778,1.5 10,1.5 Z M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 Z",
    id: "Circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69167867,14.624955 C7.49168533,14.624955 7.29169867,14.5249417 7.19167867,14.4249217 L3.891672,11.124955 C3.59166533,10.8249483 3.59166533,10.3249483 3.891672,10.0249417 C4.19167867,9.724975 4.69167867,9.724975 4.99168533,10.0249417 L7.79169867,12.8249483 L14.391692,6.224975 C14.6916987,5.92500833 15.1916987,5.92500833 15.4916853,6.224975 C15.7916987,6.52494167 15.7916987,7.02494167 15.4916853,7.32494833 L8.29169867,14.5249417 C8.00000033,14.5249417 7.79169867,14.624955 7.69167867,14.624955 Z",
    id: "Checkmark"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkInCircleNoOutline);
export default __webpack_public_path__ + "static/media/icon_checkmark_in_circle_no_outline.3dd4694d.svg";
export { ForwardRef as ReactComponent };